import { render, staticRenderFns } from "./ProductRecord.vue?vue&type=template&id=4f4ae775&scoped=true"
import script from "./ProductRecord.vue?vue&type=script&lang=js"
export * from "./ProductRecord.vue?vue&type=script&lang=js"
import style0 from "./ProductRecord.vue?vue&type=style&index=0&id=4f4ae775&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ae775",
  null
  
)

export default component.exports